"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LanguageProvider = exports.LanguageContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _contexts = require("../sfra-api/contexts");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const LanguageContext = /*#__PURE__*/_react.default.createContext({});
exports.LanguageContext = LanguageContext;
const LanguageProvider = ({
  locale,
  children
}) => {
  const SFRAClient = (0, _contexts.useCommerceSFRAAPI)();
  locale = locale.replace(/-/g, '_');
  const [i18n, setI18n] = (0, _react.useState)({
    locale: locale,
    currentCountry: {
      country: '',
      lang: '',
      config: {}
    },
    countries: [],
    error: null
  });
  (0, _react.useMemo)(() => {
    // @ts-ignore
    SFRAClient.Site.getLocales().then(({
      countries
    }) => {
      var _selectedLang$name;
      const selectedCountry = countries === null || countries === void 0 ? void 0 : countries.find(country => country.locales.find(lang => lang.locale === locale));
      const selectedLang = (selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.locales.find(lang => lang.locale === locale)) || {};
      setI18n({
        locale: locale,
        countries,
        currentCountry: {
          country: (selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.countryName) || '',
          lang: (selectedLang === null || selectedLang === void 0 ? void 0 : (_selectedLang$name = selectedLang.name) === null || _selectedLang$name === void 0 ? void 0 : _selectedLang$name.split(' ')[0]) || '',
          config: (selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.config) || {}
        }
      });
    }).catch(err => {
      setI18n(err);
    });
  }, [locale]);
  return /*#__PURE__*/_react.default.createElement(LanguageContext.Provider, {
    value: i18n
  }, children);
};
exports.LanguageProvider = LanguageProvider;